<template>
  <VListItem
    v-bind="$attrs"
    v-if="appAllowAccess(authenticated, roles, permissions) && ($attrs.debug ? isAppDebugMode : true)"
    v-debug="$attrs.debug ? isAppDebugMode : false"
    :to="cTo"
    :disabled="$attrs.disabled ?? !to"
    :color="color"
    rounded="pill"
    :title="title"
  >
    <template #prepend={isActive}>
      <VListItemAction class="mr-5">
        <VIcon :icon="isActive ? icon.replace('-outline', '') : icon" />
      </VListItemAction>
    </template>
    <template #append>
      <VIcon
        v-if="$attrs.target"
        icon="mdi-open-in-new"
        v-tooltip:top="'新しいタブで開く'"
      ></VIcon>
    </template>

  </VListItem>
</template>

<script>
import AppUtils from '@/utils/AppUtils'
export default {
  props: {
    to: {
      type: [String, Object],
      default: null
    },
    title: {
      type: String,
      default: ''
    },
    titleAppend: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: 'mdi-circle-outline'
    },
    avatar: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: 'primary'
    },
    custom: {
      type: String,
      default: ''
    },
    authenticated: {
      type: Boolean,
      default: false
    },
    roles: {
      type: Array,
      default: () => []
    },
    permissions: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    cTo() {
      if (!this.to) {
        return null
      }
      if (typeof this.to === 'string') {
        return { path: this.to, state: { fromSidebar: true } }
      }
      return Object.assign({}, this.to, { state: { fromSidebar: true } })
    },
    isAppDebugMode () {
      return AppUtils.isDebugMode()
    },
  },
  methods: {
    appAllowAccess (authenticated = false, roles = [], permissions = []) {
      return AppUtils.allowAccess(authenticated, roles, permissions)
    },
  }
}
</script>
